import { M9_UNIT_1 } from './Unit1';
import { M9_UNIT_2 } from './Unit2';
import { M9_UNIT_3 } from './Unit3';
import { M9_UNIT_4 } from './Unit4';
import { M9_UNIT_5 } from './Unit5';
import { M9_UNIT_6 } from './Unit6';
import { M9_UNIT_7 } from './Unit7';
import { M9_UNIT_8 } from './Unit8';
import { M9_UNIT_9 } from './Unit9';
import { M9_UNIT_10 } from './Unit10';
import { M9_UNIT_11 } from './Unit11';
import { M9_UNIT_12 } from './Unit12';
import { M9_UNIT_13 } from './Unit13';
import { M9_UNIT_14 } from './Unit14';
import { M9_UNIT_15 } from './Unit15';
import { M9_UNIT_16 } from './Unit16';
import { M9_READING_PRACTICE } from './ReadingPractice';
import { M9_MODULE_REVIEW } from './UnitReview';

export const MODULE_9_UNITS = [
  M9_UNIT_1,
  M9_UNIT_2,
  M9_UNIT_3,
  M9_UNIT_4,
  M9_UNIT_5,
  M9_UNIT_6,
  M9_UNIT_7,
  M9_UNIT_8,
  M9_UNIT_9,
  M9_UNIT_10,
  M9_UNIT_11,
  M9_UNIT_12,
  M9_UNIT_13,
  M9_UNIT_14,
  M9_UNIT_15,
  M9_UNIT_16,
  M9_READING_PRACTICE,
  M9_MODULE_REVIEW,
];
